module.exports = __webpack_public_path__ + "static/img/zhd.f54f9c4b.png";